// extracted by mini-css-extract-plugin
module.exports = {"Container":"Loader_Container__3m80Y","RouterLoaderAnimation":"Loader_RouterLoaderAnimation__1ImXa","Spinner":"Loader_Spinner__3BO6F","SpinnerEl":"Loader_SpinnerEl__2m1_h"};